// SEO landing pages data. Each entry powers one route via <LocationPage>.
// Content is hyper-local / event-specific for real SEO value.

export const SEO_PAGES = [
  // ---------- Location-specific ----------
  {
    slug: "luxury-restrooms-st-george",
    kind: "location",
    kicker: "St. George · Washington County",
    h1: "Luxury Restroom Rentals in St. George, Utah",
    title: "Luxury Restroom Rentals in St. George, Utah | Southern Utah Event Rentals",
    metaDescription: "Elegant restroom trailer rentals in St. George for weddings, corporate events, and private parties. Two three-stall luxury trailers, delivered and set up. Call 435.288.9909.",
    intro: "St. George is the wedding and event capital of Southern Utah — from red-rock ceremonies at Snow Canyon to poolside receptions in Entrada and reception venues along the Virgin River. When your guests deserve better than a plastic portable, our two three-stall luxury restroom trailers arrive discreetly, run on a quiet generator, and leave with your event still looking flawless.",
    localTerms: ["St. George", "Washington", "Ivins", "Santa Clara", "Hurricane", "Snow Canyon", "Entrada"],
    highlights: [
      "Serving all of Washington County including St. George, Ivins, Santa Clara, Hurricane, and Washington",
      "Popular venues: Entrada, Snow Canyon State Park, Wire Vineyard, Red Cliffs, private estates",
      "Delivery, setup, servicing, and pickup handled by our local team",
    ],
    faq: [
      { q: "Do you deliver to St. George venues?", a: "Yes — St. George is our home base. Most St. George venues are within our standard delivery area." },
      { q: "How far in advance should I book for a St. George wedding?", a: "For peak season (April–May and September–October), we recommend booking 6+ months out." },
    ],
    heroImage: "exteriorZion",
  },
  {
    slug: "luxury-restrooms-near-zion",
    kind: "location",
    kicker: "Springdale · Zion Area",
    h1: "Luxury Restrooms Near Zion National Park",
    title: "Luxury Restroom Trailer Rentals Near Zion National Park | SUER",
    metaDescription: "Luxury restroom trailers for events near Zion — Springdale weddings, Rockville private estates, and film productions. Quiet generator, ready for rural venues. Call 435.288.9909.",
    intro: "Weddings and events near Zion National Park are unforgettable — and often remote. Our luxury trailers are built for exactly that: quiet generator, solar-ready, and self-contained water, so your event can take place on any private ranch, orchard, or riverside venue without compromise. Guests get climate-controlled comfort with a view of The Watchman.",
    localTerms: ["Springdale", "Rockville", "Virgin", "Kanab", "Zion National Park entrance"],
    highlights: [
      "Perfect for remote or off-grid venues — quiet generator and self-contained water",
      "Serving Springdale, Rockville, Virgin, and areas around Zion National Park entrance",
      "Popular for elopements, private-estate weddings, and film productions on location",
    ],
    faq: [
      { q: "Can you deliver to private ranches or off-grid venues near Zion?", a: "Yes. Our trailers are built for rural venues — quiet generator, solar-ready, and self-contained water." },
      { q: "Are you permitted to deliver inside Zion National Park?", a: "Deliveries inside the park require special coordination. Contact us and we'll work through the permitting with your venue." },
    ],
    heroImage: "exteriorZion",
  },
  {
    slug: "restroom-trailer-rentals-cedar-city",
    kind: "location",
    kicker: "Cedar City · Iron County",
    h1: "Restroom Trailer Rentals in Cedar City, Utah",
    title: "Luxury Restroom Trailer Rentals in Cedar City, Utah | SUER",
    metaDescription: "Luxury restroom trailer rentals in Cedar City, Utah — for weddings, festivals, and community events. Two three-stall trailers, professional delivery. Call 435.288.9909.",
    intro: "From Southern Utah University commencement receptions to Cedar Breaks summer weddings and Iron County festivals, Cedar City deserves restrooms as elevated as the events themselves. Our two three-stall luxury trailers make the trip up I-15 for you — professionally delivered, set up, and picked up.",
    localTerms: ["Cedar City", "Enoch", "Parowan", "Brian Head", "Iron County", "Cedar Breaks"],
    highlights: [
      "Serving Cedar City, Enoch, Parowan, and Brian Head",
      "Ideal for Southern Utah University events, Cedar Breaks weddings, and Iron County festivals",
      "Climate-controlled — comfortable in mountain summers and cool fall evenings",
    ],
    faq: [
      { q: "Do you charge extra to deliver to Cedar City?", a: "A modest delivery estimate is added based on distance from St. George; we'll quote it during your booking request." },
      { q: "Can you handle Brian Head altitude and weather?", a: "Yes — our climate-controlled trailers handle mountain temperatures, and we plan setup around forecasted weather." },
    ],
    heroImage: "heroExterior",
  },

  // ---------- Event-specific ----------
  {
    slug: "wedding-restroom-trailer-rentals",
    kind: "event",
    kicker: "Weddings",
    h1: "Wedding Restroom Trailer Rentals",
    title: "Wedding Restroom Trailer Rentals in Southern Utah | Luxury Portable Restrooms",
    metaDescription: "Give wedding guests the elegance they deserve — luxury restroom trailer rentals across Southern Utah. Three-stall trailers, climate control, running water. Call 435.288.9909.",
    intro: "Your guests should never have to compromise between an unforgettable venue and a comfortable restroom. Whether you're saying vows under the Virgin River cottonwoods or hosting a reception at a private ranch, our luxury restroom trailers deliver the elegance of a five-star hotel powder room — anywhere.",
    localTerms: ["Weddings", "elopements", "receptions", "rehearsal dinners"],
    highlights: [
      "Elegant interiors — porcelain sinks, warm lighting, upscale finishes",
      "Discreet placement and quiet operation so guests barely notice they're portable",
      "Add a restroom attendant for white-glove hospitality at receptions",
    ],
    faq: [
      { q: "How many trailers do I need for my wedding?", a: "One trailer (3 stalls) serves ~150 guests comfortably; both trailers (6 stalls) work well for 200–300 guest weddings." },
      { q: "Can you place the trailer somewhere discreet?", a: "Absolutely — we walk your venue with you (or by photo/site map) to find the best placement." },
    ],
    heroImage: "wedding",
  },
  {
    slug: "concert-restroom-rentals",
    kind: "event",
    kicker: "Concerts",
    h1: "Concert Restroom Rentals",
    title: "Luxury Restroom Trailer Rentals for Concerts | Southern Utah",
    metaDescription: "Upscale restroom trailers for concerts and outdoor music events in Southern Utah. Two trailers, six stalls, quiet operation. Call 435.288.9909.",
    intro: "Nothing kills the vibe of a great show faster than a bad restroom line. Our luxury trailers keep the energy of your concert alive — six total stalls when both are on-site, running water, and elegant finishes that respect your guests. Perfect for private outdoor concerts, festival stages, and VIP hospitality zones.",
    localTerms: ["Concerts", "outdoor music", "VIP hospitality", "festival stages"],
    highlights: [
      "Six total stalls when both trailers are on-site",
      "Ideal for VIP hospitality zones and artist green-room areas",
      "Quiet generator means no hum bleeding into your live audio",
    ],
    faq: [
      { q: "Can you handle multi-day concerts?", a: "Yes — multi-day servicing is available as an add-on to keep everything spotless." },
    ],
    heroImage: "festival",
  },
  {
    slug: "festival-restroom-rentals",
    kind: "event",
    kicker: "Festivals",
    h1: "Festival Restroom Rentals",
    title: "Luxury Festival Restroom Trailer Rentals | Southern Utah",
    metaDescription: "Clean, dignified luxury restroom trailers for Southern Utah festivals. Multi-day servicing, both trailers available. Call 435.288.9909.",
    intro: "Multi-day festivals deserve better than long lines at plastic units. Our two luxury trailers arrive early, are serviced daily by our team, and hold up beautifully through the whole event — leaving your VIP guests, sponsors, and staff with a real reason to talk up your festival.",
    localTerms: ["Festivals", "multi-day events", "VIP", "sponsors"],
    highlights: [
      "Multi-day servicing to keep interiors spotless throughout the run",
      "Perfect for VIP tents, sponsor lounges, and staff hospitality zones",
      "Six stalls total when both trailers are on-site",
    ],
    faq: [
      { q: "Do you service the trailers during the festival?", a: "Yes — multi-day servicing is a popular add-on. We come by daily (or more frequently) to restock, refresh, and clean." },
    ],
    heroImage: "festival",
  },
  {
    slug: "city-event-restroom-rentals",
    kind: "event",
    kicker: "City Events",
    h1: "City Event Restroom Rentals",
    title: "Luxury Restroom Trailer Rentals for City Events | Southern Utah",
    metaDescription: "Community-friendly luxury restroom trailers for parades, city festivals, and public gatherings across Southern Utah. Call 435.288.9909.",
    intro: "City parades, holiday celebrations, and civic gatherings all deserve restrooms that reflect well on your community. Our trailers meet permit requirements, arrive on time, and leave a clean footprint — while giving residents a restroom experience worth remembering.",
    localTerms: ["Parades", "civic gatherings", "holiday events", "downtown festivals"],
    highlights: [
      "Meets standard permit and accessibility considerations for city events",
      "Discreet, upscale design that fits in with any downtown or public setting",
      "Punctual delivery and pickup — we work around your schedule",
    ],
    faq: [
      { q: "Can you deliver for a downtown block party?", a: "Yes — with reasonable street access. Share the site plan and we'll confirm placement." },
    ],
    heroImage: "champagne",
  },
  {
    slug: "corporate-event-restroom-rentals",
    kind: "event",
    kicker: "Corporate Events",
    h1: "Corporate Event Restroom Rentals",
    title: "Corporate Event Restroom Trailer Rentals | Southern Utah",
    metaDescription: "Upscale restroom trailers for corporate retreats, product launches, and executive gatherings across Southern Utah. Call 435.288.9909.",
    intro: "Executive off-sites, product launches, and VIP client gatherings need to reflect your brand — down to the restrooms. Our luxury trailers arrive professionally staged, run quietly, and can be paired with an on-site attendant for the kind of white-glove hospitality your leadership expects.",
    localTerms: ["Corporate retreats", "product launches", "executive events", "client entertainment"],
    highlights: [
      "White-glove attendant available for premium hospitality",
      "Elegant finishes that read as an extension of your brand",
      "Reliable delivery windows and on-site coordination with your event manager",
    ],
    faq: [
      { q: "Can we brand the trailer for our event?", a: "Custom signage is available as an add-on — great for company logos or event branding at the entrance." },
    ],
    heroImage: "champagne",
  },
  {
    slug: "film-production-restroom-rentals",
    kind: "event",
    kicker: "Film Productions",
    h1: "Film Production Restroom Rentals",
    title: "Film Production Restroom Trailer Rentals in Southern Utah | SUER",
    metaDescription: "Luxury restroom trailers for film productions on location in Southern Utah. Quiet generator, ready for remote and rural sets. Call 435.288.9909.",
    intro: "Southern Utah film locations mean stunning shots and remote sets. Our restroom trailers were built for exactly this: quiet generator (so audio isn't compromised), self-contained water, and enough capacity for cast, crew, and background. We coordinate with your production designer or unit manager for placement outside of frame.",
    localTerms: ["Film sets", "unit production", "cast & crew", "remote locations"],
    highlights: [
      "Quiet generator — safe for audio recording nearby",
      "Self-contained water and power for remote or off-grid sets",
      "Multi-day servicing available for extended shoots",
    ],
    faq: [
      { q: "Can you match a call sheet delivery window?", a: "Yes — we coordinate with your unit manager and can deliver early morning before crew call." },
    ],
    heroImage: "heroExterior",
  },
  {
    slug: "private-event-restroom-rentals",
    kind: "event",
    kicker: "Private Parties",
    h1: "Private Event Restroom Rentals",
    title: "Luxury Restroom Trailer Rentals for Private Parties | Southern Utah",
    metaDescription: "Discreet, upscale restroom trailers for private events, birthday parties, and estate gatherings across Southern Utah. Call 435.288.9909.",
    intro: "For private residences and estate gatherings, indoor bathrooms rarely handle the guest volume — and no host wants a queue forming down the hallway. Our luxury trailers slip discreetly onto a driveway or lawn, running on a quiet generator so nothing interrupts the mood of your evening.",
    localTerms: ["Estate parties", "birthdays", "anniversaries", "milestone celebrations"],
    highlights: [
      "Placed discreetly on driveways, lawns, or side yards",
      "Quiet operation — no generator hum bleeding into the party",
      "Great for milestone birthdays, anniversaries, and estate gatherings",
    ],
    faq: [
      { q: "Can you place the trailer on a residential driveway?", a: "Usually yes — we'll review your address and photos to confirm access." },
    ],
    heroImage: "wedding",
  },
];

export function findSeoPage(slug) {
  return SEO_PAGES.find((p) => p.slug === slug) || null;
}
